// Categoriza el "order_type" (Sale Type de STORIS) y lo resalta por color.
// Ej: "REGULAR PICKUP" -> Pickup (morado), "RETURN PICKUP" -> Devolución (rojo),
//     "SERVICE DELIVERY" -> Servicio (ámbar), "TRANSFER DELIVERY" -> Transfer (teal).

const CATS = {
  transfer: { label: "Transfer", cls: "bg-[#F0FDFA] text-[#115E59] border-[#99F6E4]" },
  return: { label: "Devolución", cls: "bg-[#FFF1F2] text-[#9F1239] border-[#FECDD3]" },
  service: { label: "Servicio", cls: "bg-[#FFFBEB] text-[#B45309] border-[#FDE68A]" },
  exchange: { label: "Canje", cls: "bg-[#EEF2FF] text-[#3730A3] border-[#C7D2FE]" },
  pickup: { label: "Pickup", cls: "bg-[#F5F3FF] text-[#5B21B6] border-[#DDD6FE]" },
  delivery: { label: "Entrega", cls: "bg-[#EFF6FF] text-[#1E3A8A] border-[#BFDBFE]" },
};

export function categorizeOrderType(orderType) {
  const o = String(orderType || "").toUpperCase();
  let category = "delivery";
  if (!o) category = "delivery";
  else if (o.includes("TRANSFER")) category = "transfer";
  else if (o.includes("RETURN")) category = "return";
  else if (o.includes("SERVICE")) category = "service";
  else if (o.includes("EXCHANGE")) category = "exchange";
  else if (o.includes("PICKUP")) category = "pickup";
  else category = "delivery";
  return { category, ...CATS[category], full: orderType || "" };
}

export function OrderTypeBadge({ orderType, fallback, className = "" }) {
  const value = orderType || fallback;
  if (!value) return <span className="text-slate-300">—</span>;
  const c = categorizeOrderType(value);
  return (
    <span
      data-testid={`order-type-badge-${c.category}`}
      title={`${value} · ${c.label}`}
      className={`inline-block text-[10px] font-semibold uppercase tracking-wide px-1.5 py-0.5 rounded-sm border whitespace-nowrap ${c.cls} ${className}`}
    >
      {value}
    </span>
  );
}
